import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../services/firebaseConfig';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const userId = userCredential.user.uid;  // ユーザーIDを取得
      onLogin(userId);  // ユーザーIDを親コンポーネントに渡す
    } catch (error) {
      alert('ログインに失敗しました: ' + error.message);
    }
  };

  return (
    <form onSubmit={handleLogin} className="bg-gray-100 p-4 rounded shadow-md">
      <h2 className="text-lg font-bold mb-4">ログイン</h2>
      <label className="block mb-2">
        メールアドレス:
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="border px-2 py-1 w-full"
        />
      </label>
      <label className="block mb-4">
        パスワード:
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="border px-2 py-1 w-full"
        />
      </label>
      <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
        ログイン
      </button>
    </form>
  );
}

export default Login;
